import { Injectable, TRANSLATIONS }   from '@angular/core';
import { isDate } from 'util';
import { getYear, getMonth, getDay, getHours, getMinutes, getSeconds, getDate } from 'date-fns';

import { Field, Condition, NumberField, IntegerField, DateField } from '../models';
import { sequence } from '@angular/core/src/animation/dsl';

@Injectable()
export class TranslatorService {
    
    constructor() { }

    private regex_identifier = /\$[{][.\w]*[}]/g;
    private TARGET_REFERENCE_INDEX:number = 1;
    private FIELD_NAME_INDEX:number = 2;
    private FORMAT_INDEX:number = 3;    

    private REF_CURRENT:string = "current";
    private REF_PREVIOUS:string = "previous";

    currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    currency_no_decimal = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0, minimumFractionDigits: 0 });
    percentage_no_decimal = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 0, minimumFractionDigits: 0 });
    toCurrency(value, decimals:number = 0) {
        var format = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: decimals, minimumFractionDigits: decimals });
        return format.format(value);
    }
    toPercentage(value, decimals:number = 0) {
        var format = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: decimals, minimumFractionDigits: decimals });
        return format.format(value);
    }

    translate(prev_item:any, current_item:any, content:string):string {
        var new_content = content;
        var identifiers = new_content.match(this.regex_identifier);
        if (identifiers && identifiers.length > 0) {
            var id_to_translation = { };
            // translate each identifier
            identifiers.forEach(i => {
                // extract id within bracket (ie '${this.current.abc}' to 'this.current.abc')
                var id = i.substring(0, i.length - 1).replace('${', '');
                var code_translation = this.translateBySystemCode(id);
                // if id was not translated (code_translation == id)
                if (code_translation == id) {
                    let tokens:string[] = id.split('.');
                    var ref_item = this.getReferenceItem(prev_item, current_item, tokens);
                    id_to_translation[i] = this.translateByItem(ref_item, tokens);
                } else {
                    id_to_translation[i] = code_translation;

                }
            });

            // replace all ientifiers with their translation
            for (const p in id_to_translation) {
                var translation = id_to_translation[p] != null ? id_to_translation[p].toString() : '';
                new_content = new_content.replace(new RegExp(this.escapeRegExp(p), 'g'), translation);
            }
        }
        return new_content;
    }

    translateBySystemCode(id) {
        var translation = id;
        if (id.indexOf('datetime.') >= 0) {
            let date:Date;
            let format:string;
            if (id.indexOf('datetime.utcnow') >= 0) {
                date = new Date();
                format = id.replace('datetime.utcnow.', '');
            } else if (id.indexOf('datetime.now') >= 0) {
                date = new Date();
                format = id.replace('datetime.now.', '');
            }
            switch (format) {
                case "total_hours": translation = (date.getTime() / 1000 / 60 / 60).toString(); break; // convert date to hours
                case "total_minutes": translation = (date.getTime() / 1000 / 60).toString(); break; // convert date to minutes
                case "total_seconds": translation = (date.getTime() / 1000).toString(); break; // convert date to seconds
                default: translation = this.getDateString(date, format); break;
            }
        }
        return translation;
    }

    escapeRegExp(exp) {
        return exp.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
      }

    getReferenceItem(prev_item:any, current_item:any, tokens:string[]) {
        if (tokens[this.TARGET_REFERENCE_INDEX].toLocaleLowerCase() == this.REF_CURRENT) return current_item;
        if (tokens[this.TARGET_REFERENCE_INDEX].toLocaleLowerCase() == this.REF_PREVIOUS) return prev_item;
        return null;
    }

    translateByItem(item:any, tokens:string[]) {
        // item is probably Array<Field<any>> from ModalComponent
        var field_name = tokens[this.FIELD_NAME_INDEX];
        var translation_format = tokens[this.FORMAT_INDEX];
        var translation = null;
        // item as Form Fields
        if (Array.isArray(item)) {
            item.forEach(i => {
                var field = this.getFormField(item, field_name);
                if (field) {
                    switch (field.data_type) {
                        case DateField.control_type: 
                            var date = new Date(field.value);
                            if (!isNaN(date.getTime())) {
                                switch (translation_format) {
                                    case "total_hours": 
                                        translation =  (date.getTime() / 1000 / 60 / 60).toString();  // convert date to hours
                                        break;
                                    case "total_minutes": 
                                        translation =  (date.getTime() / 1000 / 60).toString();  // convert date to minutes
                                        break;
                                    case "total_seconds":
                                        translation =  (date.getTime() / 1000).toString();  // convert date to seconds
                                        break;
                                    default:
                                        translation = this.getDateString(date, translation_format);
                                        break;
                                }
                            }
                            break;
                        default:
                            translation = field.value;
                            break;
                    }
                } 
            })
        } else {    
            // item as view item
            var item_field_value = item[field_name];
            // TODO handle additional value translation similiar to date.total_hours 
            switch (translation_format) {
                case "to_numeric": translation = (item_field_value == null || item_field_value == '') ? 0 : item_field_value; break;
                case "total_hours": {
                    var date = new Date(item_field_value);
                    translation =  (date.getTime() / 1000 / 60 / 60).toString();  // convert date to hours
                }
                break;
                case "total_minutes": {
                    var date = new Date(item_field_value);
                    translation =  (date.getTime() / 1000 / 60).toString();  // convert date to minutes
                }
                break;
                case "total_seconds": {
                    var date = new Date(item_field_value);
                    translation =  (date.getTime() / 1000).toString();  // convert date to seconds
                }
                break;
                default: translation = item_field_value; break;
            }
        }
        return translation;
    }

    protected Month_FullName = [
        "January",
        "Feburary",
        "March",
        "April",
        "May",
        "June",
        "July",
        "Auguest",
        "September",
        "October",
        "November",
        "December",
    ];

    protected Day_FullName = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ]

    public getDateString(date:Date, format:string):string {
        var year = getYear(date);
        var month = getMonth(date);
        var day = getDate(date);
        var hours = getHours(date);
        var minutes = getMinutes(date);
        var seconds = getSeconds(date);
        var ampm = hours > 12 ? 'PM' : 'AM';
        var day_of_week = getDay(date);

        var month_name = this.Month_FullName[month + 1];
        var month_abbr = this.Month_FullName[month + 1].substring(0, 3);
        var day_name = this.Day_FullName[day_of_week];
        var day_abbr = this.Day_FullName[day_of_week].substring(0, 3);

        // order of replacement matters
        var date_string = format;
        date_string = date_string.replace(new RegExp('yyyy', 'g'), year.toString());
        date_string = date_string.replace(new RegExp('yy', 'g'), (year % 100).toString());
        date_string = date_string.replace(new RegExp('MMMM', 'g'), month_name.toString());
        date_string = date_string.replace(new RegExp('MMM', 'g'), month_abbr.toString());
        date_string = date_string.replace(new RegExp('MM', 'g'), (month < 10 ? '0' + month.toString() : month).toString());
        date_string = date_string.replace(new RegExp('dddd', 'g'), day_name.toString());
        date_string = date_string.replace(new RegExp('ddd', 'g'), day_abbr.toString());
        date_string = date_string.replace(new RegExp('dd', 'g'), day.toString());
        date_string = date_string.replace(new RegExp('HH', 'g'), hours.toString());
        date_string = date_string.replace(new RegExp('hh', 'g'), (hours % 12).toString());
        date_string = date_string.replace(new RegExp('mm', 'g'), minutes.toString());
        date_string = date_string.replace(new RegExp('ss', 'g'), seconds.toString());
        date_string = date_string.replace(new RegExp('tt', 'g'), ampm.toString());
        return date_string;
    }

    public padStart(value:any, length:number, padString:string) {
        var text = value ? value.toString() : "";
        var remainder_length = length - text.length;
        while (remainder_length > 0) {
            text = padString + text;
            remainder_length = length - text.length
        }
    }

    public getFormField(formFields:any, key:string):Field<any> {
        for (let i = 0; i < formFields.length; i++) {
            let f = formFields[i];
            if (f.key == key) {
                return f;
            }
        };
        return null;
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/translator.service.ts